/** ---------- Sort By ------------- */
export const UserGroupsSortType = {
	Default: 'Default',
	Name: 'Name',
	UsersCount: 'UsersCount',
} as const;
export type UserGroupsSortType = (typeof UserGroupsSortType)[keyof typeof UserGroupsSortType] | keyof typeof UserGroupsSortType;

/** ---------- Sort Direction ------------- */
export const UserGroupSortDirection = {
	Asc: 'Asc',
	Desc: 'Desc',
} as const;
export type UserGroupSortDirection = (typeof UserGroupSortDirection)[keyof typeof UserGroupSortDirection];
